import * as React from "react";
type Variant="primary"|"ghost"|"danger";
const base="inline-flex items-center justify-center rounded-lg px-3 py-1.5 text-sm border";
const map:Record<Variant,string>={
  primary:"bg-cyan-600 hover:bg-cyan-500 text-white border-cyan-500",
  ghost:"bg-transparent hover:bg-white/5 text-slate-100 border-white/10",
  danger:"bg-rose-600/20 hover:bg-rose-600/30 text-rose-200 border-rose-500/30",
};
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>{variant?:Variant}
export const Button=React.forwardRef<HTMLButtonElement,ButtonProps>(({variant="primary",className,...p},ref)=>(
  <button ref={ref} className={[base,map[variant],className].filter(Boolean).join(" ")} {...p}/>
));
Button.displayName="Button"; export default Button;